<template>
  <div>
    <h2 class="content-block">Formula Builder</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxButton
          v-for="(name, value) in itemSource"
          :key="value"
          :text="name.name"
          @click="addItem($event, name.value)"
          styling-mode="outlined"
          type="default"
        />

        <br />
        <DxButton
          text="+"
          @click="addItem($event, '+')"
          styling-mode="outlined"
          type="success"
        />
        <DxButton
          text="-"
          @click="addItem($event, '-')"
          styling-mode="outlined"
          type="success"
        /><DxButton
          text="x"
          @click="addItem($event, '*')"
          styling-mode="outlined"
          type="success"
        /><DxButton
          text="/"
          @click="addItem($event, '/')"
          styling-mode="outlined"
          type="success"
        /><DxButton
          text="("
          @click="addItem($event, '(')"
          styling-mode="outlined"
          type="success"
        />
        <DxButton
          text=")"
          @click="addItem($event, ')')"
          styling-mode="outlined"
          type="success"
        />

        <div class="row">
          <div class="col-3">
            <DxSelectBox
              :dataSource="itemSource"
              valueExpr="value"
              displayExpr="name"
              :searchEnabled="true"
              styling-mode="outlined"
              :label-mode="labelMode"
              width="100%"
              placeholder="Pilih"
              label="Hitung"
            >
            </DxSelectBox>
          </div>
          <div class="col-9">
            <DxTextBox
              :show-clear-button="true"
              styling-mode="outlined"
              v-model="formulaString"
              :label-mode="labelMode"
              label="Rumus"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import DxButton from "devextreme-vue/button";
import DxTextBox from "devextreme-vue/text-box";
import DxSelectBox from "devextreme-vue/select-box";
const itemSource = [
  { name: "Honor UMK", value: "honor_umk" },
  { name: "Kenaikan Masa Kerja", value: "kenaikan_masa_kerja" },
  { name: "Tun. Kesehatan", value: "tun_kesehatan" },
  { name: "Jml Tdk Lahir", value: "jml_tdk_hadir" },
  { name: "Pot. 5 %", value: "pot_5_persen" },
  { name: "Pot. Kesehatan", value: "pot_kesehatan" },
  { name: "Pot. BPJS TK 1.19%", value: "pot_bpjs_tk_1.19_persen" },
  { name: "Pot. BPJS TK 2%", value: "pot_bpjs_tk_2_persen" },
  { name: "Gaji Pokok", value: "gaji_pokok" },
  { name: "Tun. Perushaan", value: "tun_perusahaan" },
  { name: "Tun. Jabatan", value: "tun_jabatan" },
  { name: "Tun. Kemahalan", value: "tun_kemahalan" },
  { name: "Tun. Air", value: "tun_air" },
  { name: "Tun. Transport", value: "tun_transport" },
  { name: "Tun. Pangan", value: "tun_pangan" },
  { name: "Tun. PPH", value: "tun_pph" },
  { name: "Pot. BPJS TK 3", value: "pot_bpjs_tk_3" },
  { name: "Pot. BPJS TK 4", value: "pot_bpjs_tk_4" },
  { name: "Pot. Pensiun", value: "pot_pensiun" },
  { name: "Pot. PPH", value: "pot_pph" },
];
export default {
  components: {
    DxButton,
    DxTextBox,
    DxSelectBox,
    // eslint-disable-next-line
  },
  data() {
    return {
      formulaString: "",
      itemSource: itemSource,
    };
  },

  methods: {
    addItem(variable) {
      this.formulaString = this.formulaString + variable;
    },
  },
};
</script>
